module.exports = __webpack_public_path__ + "img/icon-92.23dc970d.png";